import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, LogLine } from '../../lib/api';

export default function Logs() {
  const { id = '' } = useParams();
  const [lines, setLines] = useState<LogLine[]>([]);
  const [follow, setFollow] = useState(true);
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.logBacklog(id).then(backlog => { if (!cancelled) setLines(backlog); });
    const es = new EventSource(`/api/tenants/${id}/logs/stream`, { withCredentials: true } as any);
    es.addEventListener('log', (e: MessageEvent) => {
      try { setLines(prev => [...prev, JSON.parse(e.data)]); } catch {}
    });
    return () => { cancelled = true; es.close(); };
  }, [id]);

  useEffect(() => { if (follow) bottomRef.current?.scrollIntoView({ block: 'end' }); }, [lines, follow]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 p-3 border-b border-line text-xs">
        <label className="flex items-center gap-1 text-dim">
          <input type="checkbox" checked={follow} onChange={e => setFollow(e.target.checked)} />
          follow
        </label>
        <span className="text-dim">{lines.length} lines</span>
      </div>
      <div className="flex-1 overflow-auto px-3 py-2 text-xs leading-5">
        {lines.map((l, i) => (
          <div key={i} className={
            l.level === 'error' ? 'text-err'
            : l.level === 'warn' ? 'text-warn'
            : 'text-ink/90'
          }>
            <span className="text-dim">{l.ts.slice(11, 19)}</span>
            {l.phase && <span className="text-dim"> [{l.phase}]</span>}
            <span> {l.message}</span>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
